
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

export default function ServiceButtons() {
  const location = useLocation();

  const services = [
    { name: 'Commercial Appraisals', anchor: 'commercial' },
    { name: 'Residential Appraisals', anchor: 'residential' },
    { name: 'Estate Valuations', anchor: 'estate' },
    { name: 'Divorce Appraisals', anchor: 'divorce' },
    { name: 'Tax Appeals', anchor: 'tax-litigation' },
    { name: 'Litigation Support', anchor: 'tax-litigation' },
    { name: 'Bank & Mortgage Financing', anchor: 'bank-mortgage' },
    { name: 'Market Rent Studies', anchor: 'market-rent' }
  ];

  const handleClick = (e: React.MouseEvent, anchor: string) => {
    if (location.pathname === '/services') {
      e.preventDefault();
      const element = document.getElementById(anchor);
      if (element) {
        const headerOffset = 100;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  };

  return (
    <section className="py-16 bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h3 className="text-2xl font-bold text-black-900 mb-2 font-elegant">
            Our Appraisal Services
          </h3>
          <p className="text-gray-600 font-modern">
            Quick access to our specialized valuation services
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {services.map((service, index) => (
            <Link
              key={index}
              to={`/services#${service.anchor}`}
              onClick={(e) => handleClick(e, service.anchor)}
              className="group bg-white border-2 border-gold-400 text-gold-600 hover:bg-gold-400 hover:text-black-900 rounded-lg px-4 py-4 text-center font-semibold transition-all duration-300 cursor-pointer font-modern hover:shadow-lg transform hover:-translate-y-1 flex items-center justify-center min-h-[80px]"
            >
              <span className="block text-sm leading-tight whitespace-nowrap">
                {service.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
